<div class="header-container">
  <div class="title">
    {{ pageTitle }}
  </div>
  <dcc-close-button (buttonClick)="close()"></dcc-close-button>
</div>
<div class="input-container">
  <!-- Phases Section -->
  <div class="details-section">
    <div
      *ngFor="let phase of selectedPhases; let i = index"
      class="phase-section">
      <span class="section-title">Phase {{ i + 1 }}</span>
      <div class="phase-row">
        <content-with-label
          label="Cohorts"
          [gap]="10"
          [required]="true">
          <ng-select
            class="input-container__cohort-container__name"
            ngDefaultControl
            placeholder="Select Cohorts"
            id="{{ 'phases' + i }}"
            [multiple]="true"
            [(ngModel)]="phase.cohorts"
            (change)="tryEstimateReleaseTotal(i)">
            <ng-container *ngFor="let cohort of allCohorts">
              <ng-option
                *ngIf="!cohortExistsInOtherPhases(cohort.name, i)"
                [value]="cohort.name">
                {{ cohort.name }}
              </ng-option>
            </ng-container>
            <ng-template
              let-items="items"
              ng-multi-label-tmp>
              <div *ngIf="items.length > 1">
                {{ items.length }} Cohorts Selected
              </div>
              <div *ngIf="items.length === 1">1 Cohort Selected</div>
            </ng-template>
          </ng-select>
        </content-with-label>

        <content-with-label
          label="Expected Release Date"
          [gap]="10"
          [required]="true">
          <input
            class="input-container__cohort-container__expectedDate lx-label"
            ngDefaultControl
            onfocus="this.showPicker();"
            placeholder="Select Date"
            type="date"
            id="{{ 'expectedReleaseDate' + i }}"
            min="{{ getCurrentDate() }}"
            name="{{ 'expectedReleaseDate' + i }}"
            [(ngModel)]="
              phase.expectedReleaseDate
                ? phase.expectedReleaseDate?.split('T')[0]
                : phase.expectedReleaseDate
            "
            (ngModelChange)="onExpectedReleaseDateChange($event, i)" />
        </content-with-label>

        <button
          *ngIf="i !== 0 && i === selectedPhases.length - 1"
          class="lx-btn-small lx-btn-text remove"
          type="button"
          (click)="removePhase(i)">
          <i class="lx-icon lx-trash"></i>
        </button>
      </div>

      <div
        *ngIf="phase.cohorts.length"
        class="input__phase-cohorts-container">
        <phase-cohorts-details
          class="phase-details"
          [cohorts]="phase.cohorts"
          [devices]=""
          [online]=""></phase-cohorts-details>
      </div>
    </div>
    <a
      class="input-container__cohort-container__addPhase"
      (click)="addPhase()">
      Add Phase
    </a>
  </div>

  <!-- Apps Section -->
  <div class="details-section">
    <div class="section-title">Apps</div>
    <dcc-app-selector
      [isUpdate]="isUpdate"
      [selectedFirmwareVersions]="selectedFirmwareVersions"
      [selectedModules]="selectedModules"
      (updateFirmware)="updateFirmware($event)"
      (updateModules)="updateModules($event)"></dcc-app-selector>

    <!-- Start Estimated Release -->
    <ng-container *ngIf="estimatedTotals.potentialReleaseTotal">
      <div class="line"></div>
      <div class="">
        <div
          class="input-container__expected-release-container__title lx-title">
          Estimated Release Total
        </div>
        <div class="estimated-release-totals">
          <ng-container class="lx-body estimated-release-totals__box">
            <span class="estimated-release-totals__box__label">
              Potential Impacted Devices:
            </span>
            <span class="estimated-release-totals__box__value">
              {{ estimatedTotals.potentialReleaseTotal }}
            </span>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <!-- End Estmated Release -->
  </div>

  <!-- Name/Description Section -->
  <div class="details-section">
    <content-with-label
      label="Release Name"
      [gap]="10"
      [required]="true">
      <textarea
        id="release-name"
        name="releaseName"
        placeholder="Input Version identifier for this release"
        [(ngModel)]="releaseName"></textarea>
    </content-with-label>

    <content-with-label
      label="Release Notes"
      [gap]="10"
      [required]="true">
      <textarea
        id="description"
        name="releasesDescription"
        placeholder="Enter notes for the release"
        [(ngModel)]="releaseDescription"></textarea>
    </content-with-label>
  </div>
</div>
<div class="footer">
  <div class="footer__button-container">
    <button
      class="footer__close lx-btn lx-btn-secondary"
      (click)="close()">
      <span>Cancel</span>
    </button>
    <button
      class="footer__create lx-btn lx-btn-primary"
      [disabled]="clickSuccess"
      [innerText]="isUpdate === true ? 'Update' : 'Create'"
      (click)="handleClick()"></button>
  </div>
</div>
